export const top10QualiTranslations = {
  es: {
    title: "Top 10 Qualifying",
    loading: "Cargando...",
    placeholder: "Escribe el nombre del piloto...",
    revealTooltip: "Revelar todas las respuestas",
    back: "Volver a OverCutGames"
  },
  en: {
    title: "Top 10 Qualifying",
    loading: "Loading...",
    placeholder: "Type a driver name...",
    revealTooltip: "Reveal all answers",
    back: "Back to OverCutGames"
  }
};
